<template>
  <input-holder :inlinerows="inlinerows" :inlinerowclasses="inlinerowclasses" :label="label" :inlineLabelClass="inlineLabelClass" :inlineInputClass="inlineInputClass" :required="mandatory ? true : false" error="">
    <b-form-input v-model="text" :placeholder="placeholder" :class="classes" :type="type" v-on:keyup="keyUpHandler" :required="mandatory ? true : false" :value="text" @input="onInput" :readonly="readOnly ? true : false" :disabled="disabled" :min="minLength" :max="maxLength" :autocomplete="autocomplete"></b-form-input>
    <small class="input-error" v-if="error">{{ error }}</small>
  </input-holder>
</template>

<script>
import "../../assets/scss/input.scss";
import InputHolder from "./InputHolder.vue";

export default {
  name: "my-input",
  data() {
    return {
      text: this.$props.defaultText,
    };
  },
  components: {
    InputHolder,
  },
  methods: {
    keyUpHandler() {
      this.$emit("keyUp");
    },
    onInput() {
      this.$emit("input", this.text);
    },
  },
  props: {
    label: {
      type: String,
      required: false,
    },
    inlinerows: {
      // type: Boolean,
      default: false,
    },
    inlinerowclasses: {
      default: "mb-3",
    },
    inlineLabelClass: {
      default: "col-sm-2",
    },
    inlineInputClass: {
      default: "col-sm-10",
    },
    error: {
      type: String,
      default: "",
    },

    id: {
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: "text",
    },

    placeholder: {
      required: false,
    },
    mandatory: {
      // type: Boolean,
      default: false,
    },
    minLength: {
      default: "0",
    },
    maxLength: {
      default: "999999",
    },
    autocomplete: {
      default: "on",
    },

    classes: {
      type: String,
      default: "",
    },
    readOnly: {
      default: false,
    },
    defaultText: {
      default: "",
    },
    disabled: {
      default: null,
    },
  },
};
</script>
